import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { useHasErrors } from "../../../Hooks/useHasErrors";
import { useAppDispatch, useAppSelector } from "../../../Redux/store";
import { ProfileType } from "../../../Types/General";
import { setEmail, setFirstName, setLastName, setPassword, setPasswordConfirmation, setProgress, setSubtitle } from "../Slices/accountCreationSlice";
import { KaziPassword } from "../../../Shared Components/Kazi/KaziPassword";
import { UserDetailsSchema } from "../../../Schemas/AccountCreationSchemas";

interface UserDetailsProps {}
interface UserDetailsForm {
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    PasswordConfirmation: string; 
}

export const UserDetails = (props: UserDetailsProps) =>{
    /* ******************** Hooks ******************** */    
    const accountCreation = useAppSelector(state => state.AccountCreation);
    const dispatch = useAppDispatch();
    const {
        control,
        handleSubmit,
        formState: {isDirty, errors},
        watch,
        setError,
        clearErrors
    } = useForm<UserDetailsForm>({
        defaultValues: {
            FirstName: accountCreation.FirstName ?? "",
            LastName: accountCreation.LastName ?? "",
            Email: accountCreation.Email ?? "",
            Password: accountCreation.Password ?? "",
            PasswordConfirmation: accountCreation.PasswordConfirmation ?? "",
        },
        resolver: yupResolver(UserDetailsSchema)
    });
    const { hasErrors, getErrorMessage } = useHasErrors();
    /* ******************** Variables ******************** */
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
    /* ******************** Functions ******************** */
    dispatch(setSubtitle(`Provide a few details for your ${ProfileType[accountCreation.ProfileType!]} account`))
    const onSubmit = (data: UserDetailsForm) =>{ 
        dispatch(setFirstName(data.FirstName))
        dispatch(setLastName(data.LastName))
        dispatch(setEmail(data.Email))
        dispatch(setPassword(data.Password))
        dispatch(setPasswordConfirmation(data.PasswordConfirmation))
        dispatch(setProgress(80))
    }
    const handleBack = () =>{
        const progress = accountCreation.ProfileType === ProfileType['Client']?60:50
        dispatch(setProgress(progress))
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    console.log(errors)
    return (
        <>
            <Controller 
                name="FirstName"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(                     
                    <TextField
                        {...field}
                        error={hasErrors(field.name, errors)}
                        helperText={hasErrors(field.name, errors)?"Required":""}
                        placeholder="First Name"
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    />
                )}
            />
            <Controller 
                name="LastName"
                control={control}
                rules={{required: "Required", min: 1}}
                render={({ field }) =>(                     
                    <TextField
                        {...field}
                        error={hasErrors(field.name, errors)}
                        // helperText={hasErrors(field.name, errors)?"Required":""}
                        placeholder="Last Name"
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    />
                )}
            />
            <Controller 
                name="Email"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(  
                    <TextField
                        {...field}
                        error={hasErrors(field.name, errors)}
                        helperText={getErrorMessage(field.name, errors)}
                        placeholder="Email address"
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    />
                )}
            />
            <Controller 
                name="Password"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(  
                    <KaziPassword
                        {...field}
                        placeholder="Password"
                        error={hasErrors(field.name, errors)}
                        // helperText={hasErrors(field.name, errors)?"Required":""}
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    /> 
                )}
            />
            <Controller 
                name="PasswordConfirmation"
                control={control}
                render={({ field }) =>(  
                    <KaziPassword
                        {...field}
                        placeholder="Confirm Password"
                        error={hasErrors(field.name, errors)}
                        helperText={getErrorMessage(field.name, errors)}
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    /> 
                )}
            />
            <Box display={"flex"} flexDirection={"row"} justifyContent={"center"} alignItems={"center"} gap={2}>
                <Button variant="contained" size="large" color="secondary" onClick={handleBack}>Back</Button>
                <Button variant="contained" disabled={!isDirty || Object.keys(errors).length > 0} size="large" onClick={handleSubmit(onSubmit)}>Next</Button>
            </Box>
        </>
    )
}